import React from 'react'
import { IconFilter } from '@dostavkee/web-ui'

import { Drawer } from '@/shared/ui/drawer'
import { IconButton } from '@/shared/ui/icon-button'

import {
    RecruitmentSearchForm,
    type RecruitmentSearchFormValues,
} from './recruitment-search-form/recruitment-search-form'

type RecruitmentSearchDrawerProps = React.ComponentProps<typeof Drawer.Root> & {
    onSubmit: (values: RecruitmentSearchFormValues) => void
    searchValues: RecruitmentSearchFormValues
    onReset: () => void
}

export const RecruitmentSearchDrawer: React.FC<RecruitmentSearchDrawerProps> = ({
    onSubmit,
    searchValues,
    onReset,
    ...props
}) => {
    return (
        <Drawer.Root {...props}>
            <Drawer.Trigger asChild>
                <IconButton icon={<IconFilter />} variant='ghost' />
            </Drawer.Trigger>
            <Drawer.Content ariaDescription='Фильтр заявок'>
                <Drawer.Header title='Фильтр' />
                <Drawer.Body>
                    <RecruitmentSearchForm
                        searchValues={searchValues}
                        onReset={onReset}
                        onSubmit={onSubmit}
                    />
                </Drawer.Body>
            </Drawer.Content>
        </Drawer.Root>
    )
}
